import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ClassStatsQueryPayload,
  TaughtLessonAssignment,
} from 'src/interfaces/class-stats.types';
import { baseQuery } from 'src/store/redux';
import { prepareTaughtLessons } from 'src/utils/class-stats.utils';

export const classStatsApi = createApi({
  reducerPath: 'class-stats',
  baseQuery: baseQuery('classStats'),
  endpoints: (builder) => ({
    getTaughtLessons: builder.query<
      TaughtLessonAssignment[],
      ClassStatsQueryPayload
    >({
      query: ({ domain, classBk }) => {
        const taughtLessonsQueryParams = domain
          ? `?target_domain=${encodeURIComponent(domain)}`
          : '';

        const singleClassEndpointUrl = `classes/${classBk}/events/taught${taughtLessonsQueryParams}`;
        const multipleClassesEndpointUrl = `classes/batch-get/events/taught/${taughtLessonsQueryParams}`;

        return Array.isArray(classBk)
          ? {
              url: multipleClassesEndpointUrl,
              method: 'POST',
              body: classBk,
            }
          : singleClassEndpointUrl;
      },
      transformResponse: prepareTaughtLessons,
    }),
  }),
});

export const { useGetTaughtLessonsQuery } = classStatsApi;
